module.exports = __webpack_public_path__ + "img/db-khach-hang.198d6d99.svg";